import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 경찰청 YouTube ", -1)
const _hoisted_5 = { class: "board_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DataGrid, {
              list: $setup.list.data,
              columns: $setup.list.fields,
              totalLength: $setup.list.length,
              perPage: $setup.list.size,
              "current-page": $setup.list.currentPage,
              isShowPageBtn: true,
              onOnRowClick: $setup.moveDetail,
              onOnPaging: $setup.handlePageChange,
              onOnNextPage: $setup.handlePageChange,
              onOnPrevPage: $setup.handlePageChange,
              onOnFirstPage: $setup.handlePageChange,
              onOnLastPage: $setup.handlePageChange
            }, null, 8, ["list", "columns", "totalLength", "perPage", "current-page", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}